import { useEffect, useState } from "react";

const useSearchQuery = ({ search, data }) => {
  const [showArticles, setShowArticles] = useState([]);

  useEffect(() => {
    if (search.length) {
      let tempArr = [];
      const searchStr = search.toLowerCase();

      data.forEach((articleGroup) => {
        if (articleGroup.groupTitle.toLowerCase().includes(searchStr)) {
          tempArr = tempArr.concat(articleGroup.guideDocs);
        } else {
          articleGroup.guideDocs.forEach((article) => {
            if (
              article.guideTitle.toLowerCase().includes(searchStr) ||
              article.contents.toLowerCase().includes(searchStr)
            ) {
              tempArr.push(article);
            }
          });
        }
        setShowArticles(tempArr);
      });
    } else {
      setShowArticles([]);
    }

    // return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [search]);

  return showArticles;
};

export default useSearchQuery;
